function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { componentCls } from "../../components/style/wave";
import { cn } from "../utils";
import CSSMotion from 'rc-motion';
import { render, unmount } from 'rc-util/lib/React/render';
import raf from 'rc-util/lib/raf';
import * as React from 'react';
import { TARGET_CLS } from "./type";
import { validateNum } from "./utils";
import { jsx as _jsx } from "react/jsx-runtime";
var WaveEffect = function WaveEffect(props) {
  var className = props.className,
    target = props.target,
    component = props.component;
  var divRef = React.useRef(null);

  // const [color, setWaveColor] = React.useState<string | null>(null);
  var _React$useState = React.useState([]),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    borderRadius = _React$useState2[0],
    setBorderRadius = _React$useState2[1];
  var _React$useState3 = React.useState(0),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    left = _React$useState4[0],
    setLeft = _React$useState4[1];
  var _React$useState5 = React.useState(0),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    top = _React$useState6[0],
    setTop = _React$useState6[1];
  var _React$useState7 = React.useState(0),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    width = _React$useState8[0],
    setWidth = _React$useState8[1];
  var _React$useState9 = React.useState(0),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    height = _React$useState10[0],
    setHeight = _React$useState10[1];
  var _React$useState11 = React.useState(false),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    enabled = _React$useState12[0],
    setEnabled = _React$useState12[1];
  var waveStyle = {
    left: left,
    top: top,
    width: width,
    height: height,
    borderRadius: borderRadius.map(function (radius) {
      return "".concat(radius, "px");
    }).join(' ')
  };

  // long 和 short 单独设置
  if (target.classList.contains('ring-btn-green')) {
    waveStyle['--wave-color'] = 'var(--bds-green-100-bg)';
  } else if (target.classList.contains('ring-btn-red')) {
    waveStyle['--wave-color'] = 'var(--bds-red-100-bg)';
  } else {
    // 指定统一的 wave 颜色
    waveStyle['--wave-color'] = 'var(--bds-brand-100-bg)';
  }
  function syncPos() {
    var nodeStyle = getComputedStyle(target);

    // Get wave color from target
    // setWaveColor(getTargetWaveColor(target));

    var isStatic = nodeStyle.position === 'static';

    // Rect
    var borderLeftWidth = nodeStyle.borderLeftWidth,
      borderTopWidth = nodeStyle.borderTopWidth;
    setLeft(isStatic ? target.offsetLeft : validateNum(-parseFloat(borderLeftWidth)));
    setTop(isStatic ? target.offsetTop : validateNum(-parseFloat(borderTopWidth)));
    setWidth(target.offsetWidth);
    setHeight(target.offsetHeight);

    // Get border radius
    var borderTopLeftRadius = nodeStyle.borderTopLeftRadius,
      borderTopRightRadius = nodeStyle.borderTopRightRadius,
      borderBottomLeftRadius = nodeStyle.borderBottomLeftRadius,
      borderBottomRightRadius = nodeStyle.borderBottomRightRadius;
    setBorderRadius([borderTopLeftRadius, borderTopRightRadius, borderBottomRightRadius, borderBottomLeftRadius].map(function (radius) {
      return validateNum(parseFloat(radius));
    }));
  }
  React.useEffect(function () {
    if (target) {
      // We need delay to check position here
      // since UI may change after click
      var id = raf(function () {
        syncPos();
        setEnabled(true);
      });

      // Add resize observer to follow size
      var resizeObserver;
      if (typeof ResizeObserver !== 'undefined') {
        resizeObserver = new ResizeObserver(syncPos);
        resizeObserver.observe(target);
      }
      return function () {
        var _resizeObserver;
        raf.cancel(id);
        (_resizeObserver = resizeObserver) === null || _resizeObserver === void 0 || _resizeObserver.disconnect();
      };
    }
  }, []);
  if (!enabled) {
    return null;
  }
  var isSmallComponent = (component === 'Checkbox' || component === 'Radio') && (target === null || target === void 0 ? void 0 : target.classList.contains(TARGET_CLS));
  return /*#__PURE__*/_jsx(CSSMotion, {
    visible: true,
    motionAppear: true,
    motionName: componentCls,
    motionDeadline: 500,
    onAppearEnd: function onAppearEnd(_, event) {
      if (event.deadline || event.propertyName === 'opacity') {
        var _divRef$current;
        var holder = (_divRef$current = divRef.current) === null || _divRef$current === void 0 ? void 0 : _divRef$current.parentElement;
        if (holder) {
          unmount(holder).then(function () {
            holder === null || holder === void 0 || holder.remove();
          });
        }
      }
      return false;
    },
    children: function children(_ref) {
      var motionClassName = _ref.className;
      return /*#__PURE__*/_jsx("div", {
        ref: divRef,
        className: cn(className, {
          'wave-quick': isSmallComponent
        }, motionClassName),
        style: waveStyle
      });
    }
  });
};
var showWaveEffect = function showWaveEffect(target, info) {
  var _target$querySelector;
  var component = info.component;

  // Skip for unchecked checkbox
  if (component === 'Checkbox' && !((_target$querySelector = target.querySelector('input')) !== null && _target$querySelector !== void 0 && _target$querySelector.checked)) {
    return;
  }

  // Create holder
  var holder = document.createElement('div');
  holder.style.position = 'absolute';
  holder.style.left = '0px';
  holder.style.top = '0px';
  target === null || target === void 0 || target.insertBefore(holder, target === null || target === void 0 ? void 0 : target.firstChild);
  render( /*#__PURE__*/_jsx(WaveEffect, _objectSpread(_objectSpread({}, info), {}, {
    target: target
  })), holder);
};
export default showWaveEffect;